<ngx-mat-color-canvas
  (colorChanged)="handleColorChanged($event)"
  [color]="color"
></ngx-mat-color-canvas>
<ngx-mat-color-collection
  (colorChanged)="handleColorChanged($event)"
  [color]="color"
></ngx-mat-color-collection>
